import React from "react";
import {Loader2} from "lucide-react";
import {cn} from "../../utils/cn";

export default function Spinner({size = "md", className, ...props}) {
  const sizeClass =
    size === "sm" ? "h-3.5 w-3.5" : size === "lg" ? "h-6 w-6" : size === "xl" ? "h-8 w-8" : "h-4 w-4";
  return (
    <Loader2
      className={cn("animate-spin text-ink-400", sizeClass, className)}
      aria-label="Loading"
      {...props}
    />
  );
}
